"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Thumbnail = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/text/semantics/caption");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
const thumbnailRatioTokens = {
    '1:1': { 'aspect-ratio': '1 / 1' },
    '4:3': { 'aspect-ratio': '4 / 3' },
    full: { 'aspect-ratio': 'auto' },
};
let Thumbnail = class Thumbnail extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.src = '';
        this.alt = '';
        this.ratio = '16:9';
        this.loading = 'lazy';
        this.fetchPriority = 'auto';
        this.href = '';
        this.caption = '';
        this.hasError = false;
        this.fallbackImage = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='300'%3E%3Crect width='300' height='300' fill='%23e0e0e0'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='sans-serif' font-size='14' fill='%23999'%3ENo Image%3C/text%3E%3C/svg%3E";
    }
    render() {
        return (0, lit_1.html) `
      <figure>${this.renderImage()} ${this.renderCaption()}</figure>
    `;
    }
    renderImage() {
        const displaySrc = this.hasError ? this.fallbackImage : this.src || this.fallbackImage;
        const image = (0, lit_1.html) `
      <div class="image-wrapper">
        <img
          src=${displaySrc}
          alt=${this.alt}
          loading=${this.loading}
          decoding="async"
          fetchpriority=${this.fetchPriority}
          @error=${this.handleImageError}
        />
      </div>
    `;
        if (this.href) {
            return (0, lit_1.html) `
        <a href=${this.href}>${image}</a>
      `;
        }
        return image;
    }
    renderCaption() {
        if (!this.caption)
            return lit_1.nothing;
        // figcaption은 figure의 자식일 때만 캡션으로 매핑된다. mm-caption의 shadow 안쪽에서는
        // 평탄화 트리상 figure의 자손이 되어버리므로, 같은 shadow root에서 직접 세운다.
        return (0, lit_1.html) `
      <figcaption><mm-caption>${this.caption}</mm-caption></figcaption>
    `;
    }
    handleImageError() {
        this.hasError = true;
    }
};
Thumbnail.styles = [
    shared_styles_1.resetStyles,
    (0, lit_1.css) `
      :host {
        display: block;
        width: 100%;
        --thumbnail-border: var(--border-transparent);
        --thumbnail-border-radius: var(--radius);
        --thumbnail-background-color-empty: var(--background-subtle-color);
      }

      figure {
        display: flex;
        flex-direction: column;
        gap: var(--space-2);
        width: 100%;
      }
      img {
        height: 100%;
        object-fit: cover;
      }

      ${shared_styles_1.interactiveElement}:hover .image-wrapper {
        --thumbnail-border: var(--border);
      }
      /* a:focus-visible {
      ${shared_styles_1.focusRingStyles}
    } */

      .image-wrapper {
        width: 100%;
        position: relative;
        aspect-ratio: 16 / 9;
        border: var(--thumbnail-border);
        border-radius: var(--thumbnail-border-radius);
        box-sizing: border-box;
        background-color: var(--thumbnail-background-color-empty);
        overflow: hidden;
      }

      ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('ratio', thumbnailRatioTokens, '.image-wrapper'))}

      :host([ratio='full']) img {
        height: auto;
      }

      a {
        display: block;
        width: 100%;
        transition: all var(--transition-duration) var(--transition-easing);
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Thumbnail.prototype, "src", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Thumbnail.prototype, "alt", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Thumbnail.prototype, "ratio", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Thumbnail.prototype, "loading", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'fetchpriority' })
], Thumbnail.prototype, "fetchPriority", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Thumbnail.prototype, "href", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Thumbnail.prototype, "caption", void 0);
__decorate([
    (0, decorators_js_1.state)()
], Thumbnail.prototype, "hasError", void 0);
Thumbnail = __decorate([
    (0, decorators_js_1.customElement)('mm-thumbnail')
], Thumbnail);
exports.Thumbnail = Thumbnail;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGh1bWJuYWlsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidGh1bWJuYWlsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUErRDtBQUMvRCxxREFBa0U7QUFFbEUsc0RBQW1EO0FBQ25ELCtEQUE4RjtBQUM5RixtQ0FBbUU7QUFNbkUsTUFBTSxvQkFBb0IsR0FBcUQ7SUFDN0UsS0FBSyxFQUFFLEVBQUUsY0FBYyxFQUFFLE9BQU8sRUFBRTtJQUNsQyxLQUFLLEVBQUUsRUFBRSxjQUFjLEVBQUUsT0FBTyxFQUFFO0lBQ2xDLElBQUksRUFBRSxFQUFFLGNBQWMsRUFBRSxNQUFNLEVBQUU7Q0FDakMsQ0FBQTtBQUdNLElBQU0sU0FBUyxHQUFmLE1BQU0sU0FBVSxTQUFRLGdCQUFVO0lBQWxDOztRQXNEdUIsUUFBRyxHQUFHLEVBQUUsQ0FBQTtRQUNSLFFBQUcsR0FBRyxFQUFFLENBQUE7UUFDTyxVQUFLLEdBQW1CLE1BQU0sQ0FBQTtRQUM3QyxZQUFPLEdBQXFCLE1BQU0sQ0FBQTtRQUNOLGtCQUFhLEdBQ25FLE1BQU0sQ0FBQTtRQUNvQixTQUFJLEdBQUcsRUFBRSxDQUFBO1FBQ1QsWUFBTyxHQUFHLEVBQUUsQ0FBQTtRQUN2QixhQUFRLEdBQUcsS0FBSyxDQUFBO1FBQ3pCLGtCQUFhLEdBQ25CLGdUQUFnVCxDQUFBO0lBNkNwVCxDQUFDO0lBM0NDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBO2dCQUNDLElBQUksQ0FBQyxXQUFXLEVBQUUsSUFBSSxJQUFJLENBQUMsYUFBYSxFQUFFO0tBQ3JELENBQUE7SUFDSCxDQUFDO0lBRU8sV0FBVztRQUNqQixNQUFNLFVBQVUsR0FBRyxJQUFJLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsR0FBRyxJQUFJLElBQUksQ0FBQyxhQUFhLENBQUE7UUFDdEYsTUFBTSxLQUFLLEdBQUcsSUFBQSxVQUFJLEVBQUE7OztnQkFHTixVQUFVO2dCQUNWLElBQUksQ0FBQyxHQUFHO29CQUNKLElBQUksQ0FBQyxPQUFPOzswQkFFTixJQUFJLENBQUMsYUFBYTttQkFDekIsSUFBSSxDQUFDLGdCQUFnQjs7O0tBR25DLENBQUE7UUFFRCxJQUFJLElBQUksQ0FBQyxJQUFJLEVBQUU7WUFDYixPQUFPLElBQUEsVUFBSSxFQUFBO2tCQUNDLElBQUksQ0FBQyxJQUFJLElBQUksS0FBSztPQUM3QixDQUFBO1NBQ0Y7UUFFRCxPQUFPLEtBQUssQ0FBQTtJQUNkLENBQUM7SUFFTyxhQUFhO1FBQ25CLElBQUksQ0FBQyxJQUFJLENBQUMsT0FBTztZQUFFLE9BQU8sYUFBTyxDQUFBO1FBRWpDLGlFQUFpRTtRQUNqRSx1REFBdUQ7UUFDdkQsT0FBTyxJQUFBLFVBQUksRUFBQTtnQ0FDaUIsSUFBSSxDQUFDLE9BQU87S0FDdkMsQ0FBQTtJQUNILENBQUM7SUFFTyxnQkFBZ0I7UUFDdEIsSUFBSSxDQUFDLFFBQVEsR0FBRyxJQUFJLENBQUE7SUFDdEIsQ0FBQzs7QUEzR00sZ0JBQU0sR0FBRztJQUNkLDJCQUFXO0lBQ1gsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O1FBb0JDLGtDQUFrQjs7OztRQUlsQiwrQkFBZTs7Ozs7Ozs7Ozs7Ozs7UUFjZixJQUFBLGVBQVMsRUFBQyxJQUFBLDJCQUFtQixFQUFDLE9BQU8sRUFBRSxvQkFBb0IsRUFBRSxnQkFBZ0IsQ0FBQyxDQUFDOzs7Ozs7Ozs7OztLQVdsRjtDQUNGLENBQUE7QUFDMkI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO3NDQUFTO0FBQ1I7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO3NDQUFTO0FBQ087SUFBMUMsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7d0NBQStCO0FBQzdDO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzswQ0FBbUM7QUFDTjtJQUF2RCxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLFNBQVMsRUFBRSxlQUFlLEVBQUUsQ0FBQztnREFDL0M7QUFDb0I7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO3VDQUFVO0FBQ1Q7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzBDQUFhO0FBQy9CO0lBQVIsSUFBQSxxQkFBSyxHQUFFOzJDQUF5QjtBQTlEdEIsU0FBUztJQURyQixJQUFBLDZCQUFhLEVBQUMsY0FBYyxDQUFDO0dBQ2pCLFNBQVMsQ0E2R3JCO0FBN0dZLDhCQUFTIn0=